import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const TaxNumberForm = _ref => {
  let {
    value,
    onChange,
    disabled,
    name = 'has_tax_number'
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 10
  }, t('does_the_contractor_have_a_german_tax_number'), "*"), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    value: value !== null && value !== void 0 ? value : '',
    name: name,
    onChange: onChange,
    size: "md",
    disabled: disabled
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), /*#__PURE__*/React.createElement("option", {
    value: "true"
  }, t('yes')), /*#__PURE__*/React.createElement("option", {
    value: "false"
  }, t('no')))));
};
export default TaxNumberForm;